<!-- 优惠券弹窗内部的登录按钮 -->
<template>
  <main class="coupon-login-wrapper">
    <section class="container flex-col-center">
      <template v-if="region !== 'ru'">
        <button class="login-btn google flex-center" @click="login('google')">
          <img
            v-lazy="
              require(`@/assets/images/activities/coupon/loginbtn-google.png`)
            "
            alt="logo-1"
          />
          <span class="text">{{ $t('common.login_google') }}</span>
        </button>
        <!-- <button
          class="login-btn facebook flex-center"
          @click="login('facebook')"
          v-show="!isInMsa"
        >
          <img
            v-lazy="
              require(`@/assets/images/activities/coupon/loginbtn-facebook.png`)
            "
            alt="logo-1"
          />
          <span class="text">{{ $t('common.login_facebook') }}</span>
        </button> -->
      </template>
      <template v-else>
        <section class="round-container">
          <div class="login-btn-round google">
            <img
              class="google"
              @click="login('google')"
              v-lazy="
                require(`@/assets/images/activities/coupon/login/google.png`)
              "
            />
            <span class="name">Google</span>
          </div>
          <div class="login-btn-round vk">
            <img
              class="vk"
              @click="login('vk')"
              v-lazy="require(`@/assets/images/activities/coupon/login/vk.png`)"
            />
            <span class="name">VK</span>
          </div>
        </section>
      </template>
    </section>
    <!-- <LoginBtn :page="page" ref="loginComp" display="none" @login="loginEmit" /> -->
    <!-- <LoginBtn :page="page" ref="loginComp" v-show="false" @login="loginEmit" /> -->
  </main>
</template>

<script>
  import { mapMutations, mapState } from 'vuex'
  import { loginClick } from '@/pages/firebase'
  // import LoginBtn from '@/components/LoginBtn'
  import { isMsaWebView, jumpBrowser } from '@/utils/msa'

  export default {
    // components: { LoginBtn },
    name: 'coupon-login-btn',
    props: {
      page: {
        type: String,
        default: '',
      },
      buttonValue: {
        type: String,
        default: 'coupon',
      },
      activityId: {
        type: [Number, String],
        default: '',
      },
    },
    computed: {
      ...mapState(['userInfo', 'isMobile', 'region', 'gameName', 'isApp']),
      isInMsa() {
        return isMsaWebView()
      },
    },
    mounted() {
      const { buttonValue } = this
      // 对banner进行loginClick打点
      if (buttonValue === 'banner') {
        loginClick({ page: this.page, button: buttonValue })
      }
    },
    methods: {
      ...mapMutations(['setUserInfo', 'detail/setTuneUpLogin']),
      login(type) {
        // 用户如果在msa中，则点击登录时调用浏览器
        if (isMsaWebView()) {
          const isJump = jumpBrowser(window.location.href)
          if (isJump) return
        }

        this['detail/setTuneUpLogin']({
          type,
          option: {
            button: this.activityId,
          },
        })
      },
    },
  }
</script>

<style scoped lang="scss" src="./index.scss"></style>
<style scoped lang="scss">
  @media screen and (min-device-width: 1080px) {
    @import './index_pc.scss';
  }
</style>
